export default __webpack_public_path__ + "static/media/detalleselva.c91b8de9.jpg";